import { render, staticRenderFns } from "./standardTable.vue?vue&type=template&id=da4cc466&"
import script from "./standardTable.vue?vue&type=script&lang=js&"
export * from "./standardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports